export const MY_PRODUCTS = 'my-products';
export const DIGITAL_ASSETS = 'digital-assets';
export const PCDB = 'parts';
export const PADB = 'part-attributes';
export const BILLING = 'billing';
export const MY_FITMENTS = 'my-fitments';
export const RECEIVERS = 'receivers';
export const EXPORT_SCHEDULES = 'export-schedules';
